import React, { ReactElement } from 'react';
import { AsComponentProps } from '@payfit/growth-platform-brand-system-v2/src/types/module';
import { classNames } from '@payfit/growth-platform-brand-system-v2/src/utils/style';
import { TagBlockProps } from '@payfit/growth-platform-brand-system-v2/src/components/Tag';
import { IImage } from '../../types/module';
import { ImageProps } from '@payfit/growth-platform-brand-system-v2/src/components/Image/types';
import { Image } from '@payfit/growth-platform-brand-system-v2/src/components/Image';
import { ButtonV2Props } from '@payfit/growth-platform-brand-system-v2/src/components/ButtonV2';
import { BlogCardLayout } from '@payfit/growth-platform-brand-system-v2/src/layouts/BlogCardLayout';
import '../../sass/styles.scss';
import './fix.scss';

export interface InspirationalCardProps {
  as: AsComponentProps;
  title: string;
  subtitle: string;
  tags?: TagBlockProps[];
  capsText?: string;
  logo?: ImageProps;
  image?: IImage;
  contentPosition?: 'right' | 'left';
  ctaButton?: ReactElement<ButtonV2Props>;
  className?: string;
  linkProps?: any;
}

export const InspirationalCard = ({
  as: Component = 'div',
  title,
  subtitle,
  tags,
  capsText,
  logo,
  image,
  contentPosition,
  className,
  linkProps,
  ...props
}: InspirationalCardProps) => {
  return (
    <Component
      {...linkProps?.linkAttributes}
      className={classNames(
        'InspirationalCard',
        'group relative flex rounded-18 bg-neutral-1 bg-cover bg-center hover:shadow-m',
        contentPosition === 'right' ? 'justify-end' : 'justify-start',
        'p-24 md:p-40',
        className,
      )}
      {...props}
    >
      {image?.url && (
        <>
          <Image
            alt={image?.alt || ''}
            src={image?.url}
            className="inset-0 h-full w-full rounded-18"
            style={{ position: 'absolute' }}
            sizes={
              '(max-width: 350px) 304px, (max-width: 589px) 429px, (max-width: 769px) 606px, (max-width: 1024px) 738px, (max-width: 1248px) 488px, 612px'
            }
            pixelDensity={'image'}
            width={image?.width || 0}
            height={image?.height || 0}
          />
          <div
            className="absolute inset-0 rounded-18"
            style={{
              background:
                'linear-gradient(rgba(0, 0, 0, 0.13), rgba(0, 0, 0, 0.13))',
            }}
          />
        </>
      )}
      <div
        className={
          'InspirationalCard__content relative z-10 flex w-full flex-col overflow-hidden rounded-12 bg-neutral-1 sm:w-3/5 md:w-3/5'
        }
      >
        <BlogCardLayout
          cardType={'InspirationalCard'}
          title={title}
          subtitle={subtitle}
          tags={tags}
          capsText={capsText}
          logo={logo}
          ctaButton={linkProps.button}
          hasTransparentBorders
          imgPosition="none"
        />
      </div>
    </Component>
  );
};
